import type { ReactElement } from 'react'

import { CheckoutButton } from '../../templateComponents/Cart/CheckoutButtons'
import CartTemplateComponent from '../../templateComponents/Cart/Cart'
import LineItem from '../../templateComponents/Cart/LineItem'
import LineItems from '../../templateComponents/Cart/LineItems'
import Link from '../../templateComponents/Link'

export default function Cart({ t, cart, shop }: CartThemeComponentProps): ReactElement {
  return (
    <CartTemplateComponent>
      <div className="template-cart">
        {cart.totalNumberOfItems > 0 && (
          <div>
            {cart.checkoutState && !cart.checkoutState.priceValidToOrder && cart.minimumOrderValue && (
              <div className="cart-warning-message">
                {t('views.storefrontView.basketPageSection.checkoutValidation.cartMinimumAmountNotReached', {
                  amount: cart.minimumOrderValue.formatted,
                })}
              </div>
            )}

            <LineItems
              tagName="div"
              renderItem={(lineItem) => (
                <div>
                  {lineItem.imageUrl && (
                    <Link to={lineItem.productUrl}>
                      <img src={lineItem.imageUrl} />
                    </Link>
                  )}

                  <div className="product-link">
                    <Link to={lineItem.productUrl}>{lineItem.name}</Link>
                    {lineItem.essentialFeatures && <p>{lineItem.essentialFeatures}</p>}
                  </div>

                  <div>{cart.grandAmount}</div>
                  <div>{lineItem.quantity.unit}</div>

                  {!shop.beyond && (
                    <LineItem.AddToWishlistLinkInCart className="cart-add-wishlist-link">
                      <span>&lt;3</span>
                    </LineItem.AddToWishlistLinkInCart>
                  )}
                  <LineItem.RemoveLineItemButton className="remove-from-cart">
                    <span>X</span>
                  </LineItem.RemoveLineItemButton>
                </div>
              )}
            ></LineItems>

            <div>
              <div>{cart.subAmount}</div>
              {cart.shippingLineItem && <pre>{JSON.stringify(cart.shippingLineItem, null, 2)}</pre>}
              <div>{cart.grandTotal.formatted}</div>
            </div>

            <CheckoutButton className="checkout-button">
              <span>Checkout</span>
            </CheckoutButton>
          </div>
        )}
      </div>
    </CartTemplateComponent>
  )
}
